import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { productsearchProduct, postaddWebfeed, getOrderListByIdApi, ReassignDriverApi, ProvideRefundApi, GatewayPaymentList, getWebfeedCommentList, updateWebfeed, getwebfeedListApi, getDriverListApi, generatePrintInvoice, generateShippingLabel, orderDoneApi, bulkStatusUpdate, getReturnOrderListApi, cancleOrder, orderReturnStatusUpdateApi, getOrderListApi, getDriverOrderListApi, generateInvoiceApi, getOrderListByCustomerApi, postOrderbyidApi, postwebfeedbyidApi, updateorder, getnationsList, getemirateList, updateStatusApi, getareaListApi, getListtabsApi, postgetCustomer, postOrderApi, commentsApi, postwebCommentApi, AssignDriverApi, getProductallinvApi } from '../services/Apis';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useParams } from "react-router-dom";
import { toast } from 'react-toastify';
export default function useOrder() {
    const { slug } = useParams()
    const initial_page = useSelector(state => state.globalslice.initial_page);
    // const perPage = useSelector(state => state.globalslice.perPage);
    const sorting_data = useSelector(state => state.globalslice.sorting_data);

    const queryClient = useQueryClient();
    const navigate = useNavigate()

    const postOrder = useMutation({
        mutationFn: (formData) => {
            if (formData.id) {
                return updateorder(formData, slug); // if id exists — update
            } else {
                return postOrderApi(formData);    // else — create
            }
        },
        onSuccess: (data) => {
            toast.success('Order Updated Successfully', 200)

            queryClient.getQueryCache().findAll().forEach((query) => {
                if (query.queryKey[0] === 'order_list') {
                    queryClient.removeQueries({ queryKey: query.queryKey });
                }
            });
            queryClient.invalidateQueries({ queryKey: ['OrderbyidApi', { id: data?.data.toString() }] });
            navigate('/order/list')
        },
        onError: (error) => {
            console.error('customer failed', error);
        },
    });

    const AssignDriver = useMutation({
        mutationFn: (formData) => {
            return AssignDriverApi(formData)
        },
        onSuccess: (data) => {
            // console.log(queryClient.getQueryCache().getAll());
            toast.success('Assign Successfully', 200)


            queryClient.invalidateQueries({ queryKey: ['order_list'], exact: false });

            queryClient.getQueryCache().findAll().forEach((query) => {
                if (query.queryKey[0] == 'driverorder_list') {
                    queryClient.removeQueries({ queryKey: query.queryKey });
                }
            });
            queryClient.invalidateQueries({ queryKey: ['returnorderlist'], exact: false });
        },
        onError: (error) => {
            console.error('Driver Assign failed', error);
        },
    });

    const ProvideRefund = useMutation({
        mutationFn: (formData) => {
            return ProvideRefundApi(formData)
        },
        onSuccess: (data) => {
            toast.success('Updated Successfully', 200)

            if (data?.data?.return_type == 'replacement') {
                navigate(`/order/addOrder/${data?.data?.orderid}`)
            }
            if (data?.data?.return_type === 'refund') {
                // Open in new tab
                window.open(`/crm/addComplaint/${data?.data?.ticket_id}`, '_blank');
            }
            // queryClient.invalidateQueries({ queryKey: ['order_list'], exact: false });
            // queryClient.invalidateQueries({ queryKey: ['DriverOrderList'], exact: false });
        },
        onError: (error) => {
            console.error('customer failed', error);
        },
    });


    const orderReturnStatusUpdate = useMutation({
        mutationFn: (formData) => {
            return orderReturnStatusUpdateApi(formData)
        },
        onSuccess: (data) => {
            toast.success('Updated Successfully', 200)

            queryClient.invalidateQueries({ queryKey: ['returnorderlist'], exact: false });
        },
        onError: (error) => {
            console.error('orderReturnStatusUpdateApi failed', error);
        },
    });

    const postcomments = useMutation({
        mutationFn: (formData) => {
            return commentsApi(formData)
        },
        onSuccess: (data) => {
            toast.success('Comments Updated Successfully', 200)

            queryClient.getQueryCache().findAll().forEach((query) => {
                if (query.queryKey[0] === 'orderComment') {
                    queryClient.removeQueries({ queryKey: query.queryKey });
                }
            });
            queryClient.invalidateQueries({ queryKey: ['OrderbyidApi', { id: slug }] });
        },
        onError: (error) => {
            console.error('customer failed', error);
        },
    });

    const postgenerateinvoice = useMutation({
        mutationFn: generateInvoiceApi,

        onSuccess: (data) => {
            toast.success('Invoice Generated Successfully', 200)

            queryClient.invalidateQueries({ queryKey: ['order_list'], exact: false });
        },

        onError: (error) => {
            console.error('Invoice generation failed:', error);
        },
    });
    const postorderDoneApi = useMutation({
        mutationFn: orderDoneApi,
        onSuccess: (data) => {
            toast.success('Delivered Done Successfully', 200)
            queryClient.invalidateQueries({ queryKey: ['order_list'], exact: false });
        },

        onError: (error) => {
            console.error('order done failed:', error);
        },
    });
    const postReassignDriverApi = useMutation({
        mutationFn: ReassignDriverApi,
        onSuccess: (data) => {
            toast.success('Reassign Successfully', 200)
            queryClient.invalidateQueries({ queryKey: ['order_list'], exact: false });
        },

        onError: (error) => {
            console.error('order done failed:', error);
        },
    });

    const generateShippingLabelApi = useMutation({
        mutationFn: generateShippingLabel,


        onSuccess: (response) => {
            const downloadUrl = response?.data?.download_url;
            if (downloadUrl) {
                window.open(downloadUrl, "_blank");
            }
            toast.success('Generated Successfully', 200)
        },
        onError: (error) => {
            console.error("Shipping label generation failed", error);

        },



    });
    const generatePrintInvoiceApi = useMutation({
        mutationFn: generatePrintInvoice,


        onSuccess: (response) => {
            const downloadUrl = response?.data?.download_url;
            if (downloadUrl) {
                window.open(downloadUrl, "_blank");
            }
            toast.success('Generated Successfully', 200)
        },
        onError: (error) => {
            console.error("print invoice failed", error);

        },



    });
    const cancleOrderapi = useMutation({
        mutationFn: cancleOrder,

        onSuccess: (data) => {
            toast.success('Cancle Successfully', 200)


            queryClient.invalidateQueries({ queryKey: ['order_list'], exact: false });
            queryClient.invalidateQueries({ queryKey: ['driverorder_list'], exact: false });
        },

        onError: (error) => {
            console.error('Invoice generation failed:', error);
        },
    });
    const bulkStatusUpdateapi = useMutation({
        mutationFn: (formData) => {
            return bulkStatusUpdate(formData)
        },

        onSuccess: (data) => {
            toast.success('Updated Successfully', 200)

            queryClient.invalidateQueries({ queryKey: ['order_list'], exact: false });
            // queryClient.invalidateQueries({ queryKey: ['driverorder_list'], exact: false });
        },

        onError: (error) => {
            console.error('delivered failed:', error);
        },
    });

    const getOrderList = (perPage, list_key, type, countryid, emirate, area, dateRange) => {
        return useQuery({
            queryKey: ['order_list', { 'page': initial_page, limit: perPage, sort: sorting_data?.sortBy ? sorting_data.sortBy : '', [type]: list_key, 'country_id': countryid, 'emirate': emirate, 'area': area, order: sorting_data?.sortOrder ? sorting_data?.sortOrder : 'desc', search: sorting_data.search, 'from_date': dateRange[0], 'to_date': dateRange[1] }],
            queryFn: () => getOrderListApi({ 'page': initial_page, limit: perPage, [type]: list_key, sort: sorting_data?.sortBy ? sorting_data.sortBy : '', 'country_id': countryid, 'emirate': emirate, 'area': area, order: sorting_data?.sortOrder ? sorting_data?.sortOrder : 'desc', search: sorting_data.search, 'from_date': dateRange[0], 'to_date': dateRange[1] }),
            enabled: countryid > 0,
            cacheTime: Infinity,
            refetchOnMount: false,
            staleTime: Infinity,
        });
    }

    const ReturnOrderList = (list_key, countryid, dateRange, perPage) => {
        return useQuery({
            queryKey: ['returnorderlist', { 'page': initial_page, limit: perPage, sort: sorting_data?.sortBy ? sorting_data.sortBy : '', 'country_id': countryid, 'return_status': list_key, order: sorting_data?.sortOrder ? sorting_data?.sortOrder : 'desc', search: sorting_data.search, 'from_date': dateRange[0], 'to_date': dateRange[1] }],
            queryFn: () => getReturnOrderListApi({ 'page': initial_page, limit: perPage, 'return_status': list_key, sort: sorting_data?.sortBy ? sorting_data.sortBy : '', 'country_id': countryid, order: sorting_data?.sortOrder ? sorting_data?.sortOrder : 'desc', search: sorting_data.search, 'from_date': dateRange[0], 'to_date': dateRange[1] }),
            cacheTime: Infinity,
            refetchOnMount: false,
            staleTime: Infinity,
        });
    }
    const getDriverOrderList = (list_key, dateRange, countryid, perPage) => {
        return useQuery({
            queryKey: ['driverorder_list', { country_id: countryid, 'page': initial_page, limit: perPage, sort: sorting_data?.sortBy ? sorting_data.sortBy : '', 'driver_status': list_key, updated_date: sorting_data?.sortOrder ? sorting_data?.sortOrder : 'desc', search: sorting_data.search, 'from_date': dateRange[0], 'to_date': dateRange[1] }],
            queryFn: () => getDriverOrderListApi({ country_id: countryid, 'page': initial_page, limit: perPage, 'driver_status': list_key, sort: sorting_data?.sortBy ? sorting_data.sortBy : '', updated_date: sorting_data?.sortOrder ? sorting_data?.sortOrder : 'desc', search: sorting_data.search, 'from_date': dateRange[0], 'to_date': dateRange[1] }),
            cacheTime: Infinity,
            refetchOnMount: false,
            staleTime: Infinity,
        });
    }

    const GetDriverList = (countryid) => {
        return useQuery({
            queryKey: ['DriverList', { 'page': initial_page, limit: process.env.REACT_APP_PER_PAGE, sort: sorting_data?.sortBy ? sorting_data.sortBy : 'orderid', 'country_id': countryid, order: sorting_data?.sortOrder ? sorting_data?.sortOrder : 'desc', search: sorting_data.search }],
            queryFn: () => getDriverListApi({ 'page': initial_page, limit: process.env.REACT_APP_PER_PAGE, 'country_id': countryid, sort: sorting_data?.sortBy ? sorting_data.sortBy : 'orderid', order: sorting_data?.sortOrder ? sorting_data?.sortOrder : 'desc', search: sorting_data.search }),
            cacheTime: Infinity,
            refetchOnMount: false,
            staleTime: Infinity,
        });
    }

    const productsearchProductApi = (query) => {
        return useQuery({
            queryKey: ['searchProduct', { id: query }],
            queryFn: () => productsearchProduct(query),
            enabled: !!query,
            cacheTime: Infinity,
            refetchOnMount: false,
            staleTime: Infinity,
        });
    }

    const getOrderListById = (id) => {
        return useQuery({
            queryKey: ['getOrderById', { 'id': id }],
            queryFn: () => getOrderListByIdApi(id),
            enabled: !!id,   // <--- only run if id (slug) exists
            cacheTime: Infinity,
            refetchOnMount: false,
            staleTime: Infinity,
        });
    }
    const postOrderbyid = (id) => {
        return useQuery({
            queryKey: ['OrderbyidApi', { 'id': id }],
            queryFn: () => postOrderbyidApi(id),
            enabled: !!id,   // <--- only run if id (slug) exists
            cacheTime: Infinity,
            refetchOnMount: false,
            staleTime: Infinity,
        });
    }

    const postgetCustomerApi = useMutation({
        mutationFn: (data) => postgetCustomer(data),
    });
    const updateStatus = useMutation({
        mutationFn: (data) => updateStatusApi(data),
    });

    const getListtabs = () => {
        return useQuery({
            queryKey: ['getListtabs'],
            queryFn: () => getListtabsApi(),
            // <--- only run if id (slug) exists
            cacheTime: Infinity,
            refetchOnMount: false,
            staleTime: Infinity,
        });
    }

    const getemirateListApi = (id) => {
        return useQuery({
            queryKey: ['getemirateList', { 'country_id': id }],
            queryFn: () => getemirateList({ 'country_id': id }),
            enabled: !!id,
            // <--- only run if id (slug) exists
            cacheTime: Infinity,
            refetchOnMount: false,
            staleTime: Infinity,
        });
    }
    const getnationsListApi = () => {
        return useQuery({
            queryKey: ['getnationsList'],
            queryFn: () => getnationsList(),
            // <--- only run if id (slug) exists
            cacheTime: Infinity,
            refetchOnMount: false,
            staleTime: Infinity,
        });
    }
    const getGatewayPaymentListapi = () => {
        return useQuery({
            queryKey: ['getGatewayPaymentList'],
            queryFn: () => GatewayPaymentList(),
            // <--- only run if id (slug) exists
            cacheTime: Infinity,
            refetchOnMount: false,
            staleTime: Infinity,
        });
    }
    const getareaList = () => {
        return useQuery({
            queryKey: ['getareaList'],
            queryFn: () => getareaListApi(),
            // <--- only run if id (slug) exists
            cacheTime: Infinity,
            refetchOnMount: false,
            staleTime: Infinity,
        });
    }

    const getOrderByCustomerId = (id, phone) => {
        return useQuery({
            queryKey: ['OrderByCustomer', { 'id': id, 'contact': phone, 'page': initial_page, limit: process.env.REACT_APP_PER_PAGE, sort: sorting_data?.sortBy ? sorting_data.sortBy : 'orderid', order: sorting_data?.sortOrder ? sorting_data?.sortOrder : 'desc', search: sorting_data.search }],
            queryFn: () => getOrderListByCustomerApi({ 'id': id, 'contact': phone, 'page': initial_page, limit: process.env.REACT_APP_PER_PAGE, sort: sorting_data?.sortBy ? sorting_data.sortBy : 'orderid', order: sorting_data?.sortOrder ? sorting_data?.sortOrder : 'desc', search: sorting_data.search }),
            enabled: !!id || !!phone,
            cacheTime: Infinity,
            refetchOnMount: false,
            staleTime: Infinity,
        });
    }


    const postwebfeed = useMutation({
        mutationFn: (formData) => {
            if (formData.id) {
                return updateWebfeed(formData, slug); // if id exists — update
            } else {
                return postaddWebfeed(formData);    // else — create
            }
        },
        onSuccess: (data) => {
            toast.success('Updated Successfully', 200)

            queryClient.getQueryCache().findAll().forEach((query) => {
                if (query.queryKey[0] === 'webfeed_list') {
                    queryClient.removeQueries({ queryKey: query.queryKey });
                }
            });
            queryClient.invalidateQueries({ queryKey: ['webfeedbyidApi', { id: data?.data.toString() }] });
            navigate('/webfeed/list')
        },
        onError: (error) => {
            console.error('customer failed', error);
        },
    });
    const postwebComment = useMutation({
        mutationFn: (formData) => {
            return postwebCommentApi(formData)
        },
        onSuccess: (data) => {
            queryClient.getQueryCache().findAll().forEach((query) => {
                if (query.queryKey[0] === 'webfeed_comment_list') {
                    queryClient.removeQueries({ queryKey: query.queryKey });
                }
            });
            queryClient.invalidateQueries({ queryKey: ['webfeedbyidApi', { id: slug }] });
            // queryClient.invalidateQueries({ queryKey: ['webfeed_comment_list', { id: slug }] });
        },
        onError: (error) => {
            console.error('webfeed customer failed', error);
        },
    });

    const getwebfeedList = (perPage, country_id, activeTabId) => {
        return useQuery({
            queryKey: [
                'webfeed_list',
                {
                    callback: activeTabId, // keep actual id, not boolean
                    country_id,
                    page: initial_page,
                    limit: perPage,
                    sort: sorting_data?.sortBy || '',
                    search: sorting_data.search,
                },
            ],
            queryFn: () =>
                getwebfeedListApi({
                    callback: activeTabId === 1 ? false : true, // you can still send boolean to API
                    country_id,
                    page: initial_page,
                    limit: perPage,
                    sort: sorting_data?.sortBy || '',
                    search: sorting_data.search,
                }),
            enabled: country_id > 0,
            cacheTime: Infinity,
            refetchOnMount: false,
            staleTime: Infinity,
        });
    };

    const getWebfeedCommentListapi = (webfeedid) => {
        return useQuery({
            queryKey: ['webfeed_comment_list', webfeedid],
            queryFn: () => getWebfeedCommentList(webfeedid),
            cacheTime: Infinity,
            refetchOnMount: false,
            staleTime: Infinity,
        });
    }

    const postwebfeedbyid = (id) => {
        return useQuery({
            queryKey: ['webfeedbyidApi', { 'id': id }],
            queryFn: () => postwebfeedbyidApi(id),
            enabled: !!id,   // <--- only run if id (slug) exists
            cacheTime: Infinity,
            refetchOnMount: false,
            staleTime: Infinity,
        });
    }

    const getProductallinv = (id) => {
        return useQuery({
            queryKey: ['ProductallinvApi', id],
            queryFn: () => getProductallinvApi(id),
            enabled: !!id,
            cacheTime: Infinity,
            refetchOnMount: false,
            staleTime: Infinity,
        });
    }

    return {
        postOrder: postOrder,
        postwebfeed: postwebfeed,
        getOrderList: getOrderList,
        getOrderListById: getOrderListById,
        getProductallinv: getProductallinv,
        getListtabs: getListtabs,
        productsearchProductApi: productsearchProductApi,
        postgetCustomerApi: postgetCustomerApi,
        getemirateListApi: getemirateListApi,
        getnationsListApi: getnationsListApi,
        getGatewayPaymentListapi: getGatewayPaymentListapi,
        getareaList: getareaList,
        postOrderbyid: postOrderbyid,
        postcomments: postcomments,
        postwebComment: postwebComment,
        postgenerateinvoice: postgenerateinvoice,
        AssignDriver: AssignDriver,
        getDriverOrderList: getDriverOrderList,
        ReturnOrderList: ReturnOrderList,
        ProvideRefund: ProvideRefund,
        GetDriverList: GetDriverList,
        getwebfeedList: getwebfeedList,
        cancleOrderapi: cancleOrderapi,
        updateStatus: updateStatus,
        postorderDoneApi: postorderDoneApi,
        getOrderByCustomerId: getOrderByCustomerId,
        postwebfeedbyid: postwebfeedbyid,
        bulkStatusUpdateapi: bulkStatusUpdateapi,
        getWebfeedCommentListapi: getWebfeedCommentListapi,
        orderReturnStatusUpdate: orderReturnStatusUpdate,
        generateShippingLabelApi: generateShippingLabelApi,
        generatePrintInvoiceApi: generatePrintInvoiceApi,
        postReassignDriverApi: postReassignDriverApi,
    };
}